/* eslint-disable perfectionist/sort-enums */

export enum AD_TYPE {
  NO_AD = 0,
  CSAI = 1,
  SSAI = 2,
}

/* eslint-enable perfectionist/sort-enums */
